export const trunc = (value: number, decimals: number = 2) => {
  return +value.toFixed(decimals);
}



// WEBPACK FOOTER //
// ./src/app/common/utils/trunc.ts